import React from "react";
import "./PortfolioStudy.scss";

import feature3 from "../../assets/images/UniqueFeatures-2.png";
import feature4 from "../../assets/images/UniqueFeatures-1.png";
import feature5 from "../../assets/images/Phone.png";
import feature6 from "../../assets/images/Tablet-view.png";
import feature7 from "../../assets/images/flyer.png";
import feature8 from "../../assets/images/flyer-1.png";
import feature9 from "../../assets/images/Phone-mockup.png";
import topography from "../../assets/images/Typography1.png";
import Slide10 from "../../assets/images/Slide-10.png";

const PortfolioStudy = () => {
  return (
    <>
      <section className="section portfolioStudy">
        <article className="portfolioStudy__container container">
          <div className="portfolioStudy__container--content1">
            <div className="content1-left">
              <h3>Style Guides</h3>
              <p>
                This style guide aimed to communicate a sense of sophistication,
                luxury, seamless, and user-centricity, aligning Drapme’s visual
                identity with its status as a chauffeur platform.
              </p>
            </div>
            <figure className="content1-right">
              <img
                src={topography}
                alt="topography"
                width={1000}
                height={1000}
              />
            </figure>
          </div>

          <div className="portfolioStudy__container--content2">
            <div className="content2-left">
              <figure>
                <img src={feature4} alt="feature3" width={1000} height={1000} />
              </figure>
              <figure>
                <img src={feature3} alt="feature3" width={1000} height={1000} />
              </figure>
            </div>

            <div className="content2-right">
              <div className="content2-right--text">
                <h3>Popular Destinations</h3>
                <p>
                  A unique feature on the app that displays popular destinations
                  around your location, so instead of searching for a
                  destination be it restaurant or a new hotel for tourist you
                  have a whole option to choose from by tap on it and it takes
                  you there.
                </p>
              </div>
              <div className="content2-right--text">
                <h3>Ride Scheduling</h3>
                <p>
                  Scheduling trips without hassle, you book a ride for later and
                  cancel whenever and wherever you are, and no cancelation fee
                  will be added to you charges as you get refunded.
                </p>
              </div>
            </div>
          </div>

          <div className="portfolioStudy__container--content3">
            <figure>
              <img src={Slide10} alt="Slide10" width={1000} height={1000} />
            </figure>
          </div>

          <div className="portfolioStudy__container--content4">
            <div className="content4-left">
              <h3>Book a ride online</h3>
              <p>
                You can also book and manage rides on the web app search for
                available chauffeurs and get connected to them, subscribe to
                newsletter get daily updates and more on the website.
              </p>
            </div>
            <div className="content4-right">
              <figure>
                <img src={feature5} alt="feature5" width={1000} height={1000} />
              </figure>

              <figure>
                <img src={feature6} alt="feature6" width={1000} height={1000} />
              </figure>
            </div>
          </div>

          <div className="portfolioStudy__container--content5">
            <div className="content5-left">
              <h3>City to city rides</h3>
              <p>
                You can also book and manage rides on the web app search for
                available chauffeurs and get connected to them, subscribe to
                newsletter get daily updates and more on the website.
              </p>
            </div>
            <div className="content5-right">
              <figure>
                <img src={feature7} alt="feature5" width={1000} height={1000} />
              </figure>

              <figure>
                <img src={feature8} alt="feature6" width={1000} height={1000} />
              </figure>
            </div>
          </div>

          <div className="portfolioStudy__container--content6">
            <div className="content6-left">
              <h3>Features</h3>
              <p>
                You can also book and manage rides on the web app search for
                available chauffeurs and get connected to them, subscribe to
                newsletter get daily updates and more on the website.
              </p>
            </div>
            <div className="content6-right">
              <figure>
                <img src={feature9} alt="feature5" width={1000} height={1000} />
              </figure>
            </div>
          </div>
        </article>
      </section>
    </>
  );
};

export default PortfolioStudy;
